import styled from 'styled-components';
import { fonts } from 'coreComponents/design-system/variables/fonts/fonts';
import { colors } from 'coreComponents/design-system/variables/colors/colors';
export const Paragraph = styled.div `
  color: ${colors.darkGray};
  font-family: ${fonts.AvenirNext.regular};
  font-size: 16px;

  ${({ color }) => {
    if (color) {
        return `color: ${color};`;
    }
}}
`;
export const Link = styled.a `
  color: ${colors.navyBlue};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${colors.mediumBlue};
  }
`;
export const h2 = styled.div `
  color: ${colors.darkGray};
  font-family: ${fonts.KapraNeue.regular};
  font-size: 36px;
`;
